const state = {
    users: [],
    usersId: [],
    role: [],
    loading: false
};

export default state;